import React, { useState, useEffect, useRef, useContext } from 'react';
import classnames from 'classnames';
import Slider from 'react-slick';
import Context from '../../container';
import usePlatform from '../../hooks/usePlatform';
import { isSSR } from '../../scripts/utils';
import Single from './Single';

export default function Multiple({ covered, height, paddingTop, config, setCurrentThemeCallback, useArrow = false, useDots = true }) {
  const [ing, setIng] = useState(false);
  const [themes, setThemes] = useState([]);
  const { isPc } = usePlatform() || {};
  const { hasMask } = useContext(Context);
  const ref = useRef();
  const slider = useRef();

  useEffect(() => {
    if (hasMask) {
      slider.current.slickPause();
    } else {
      slider.current.slickPlay();
    }
  }, [hasMask]);

  useEffect(() => {
    setCurrentThemeCallback(themes[0]);
  }, [themes[0]]);

  const settings = useArrow && useDots ? {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    beforeChange: (prevIndex, index) => {
      setIng(true);
      setCurrentThemeCallback(themes[index]);
    },
    afterChange: () => {
      setIng(false);
    },
  } :{
    dots: true,
    arrows: isPc ? useArrow : false,
    infinite: true,
    speed: 500,
    swipe: !isPc,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (prevIndex, index) => {
      setIng(true);
      setCurrentThemeCallback(themes[index]);
    },
    afterChange: () => {
      setIng(false);
    },
    appendDots: useArrow ? () => <></> : (dots) => (
      <div>
        <div className="comp-root">
          <ul className={classnames({ ing })}>{dots}</ul>
        </div>
      </div>
    )
  };

  // 在 SSR 环境中只渲染第一个配置项，避免 Slider 组件问题
  if (isSSR) {
    return (
      <div ref={ref}>
        {config.length > 0 && (
          <div>
            <Single
              covered={covered}
              height={height}
              paddingTop={paddingTop}
              setThemeCallback={setCurrentThemeCallback}
              {...config[0]}
            />
            {/* 添加与 Slider 组件相同的结构，确保 hydration 匹配 */}
            <div>
              <div className="comp-root">
                <ul className={classnames({ ing })}></ul>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div ref={ref} className={classnames({ 'show-dots-arrow': useDots && useArrow })}>
      <Slider {...settings} ref={slider} className='slider'>
        {config.map((conf, index) => (
          <Single
            key={`banner-${index}`}
            covered={covered}
            height={height}
            paddingTop={paddingTop}
            setThemeCallback={(theme) => {
              themes[index] = theme;
              setThemes([...themes]);
            }}
            {...conf}
          />
        ))}
      </Slider>
    </div>
  );
}
